<div class="card h-100">
  <div class="card-body">
    @if (showTitle()) {
      <h6 class="card-title mb-3">Report Card</h6>
    }

    <div class="text-center mb-3">
      <span class="badge fs-6" [class]="alignmentConfig().bootstrapClass">
        {{ alignmentConfig().label }}
      </span>
    </div>

    <div echarts [options]="chartOptions()" [initOpts]="{ renderer: 'canvas' }" style="height: 260px; width: 100%"></div>

    <div class="mt-3">
      @for (item of statusBreakdown(); track item.label) {
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="d-flex align-items-center gap-2">
            <span class="status-dot" [style.background-color]="item.color"></span>
            <span class="text-muted small">{{ item.label }}</span>
          </div>
          <span class="fw-bold">{{ item.count }}</span>
        </div>
      }
      <hr class="my-2" />
      <div class="d-flex justify-content-between align-items-center">
        <span class="text-muted small fw-bold">Total Findings</span>
        <span class="fw-bold">{{ reportCard().total_findings }}</span>
      </div>
    </div>
  </div>
</div>
